import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCdjYMcuCSSTkmgwiDVHSfM-AVkzz-r6SM",
  authDomain: "sunstore-crm.firebaseapp.com",
  projectId: "sunstore-crm",
  storageBucket: "sunstore-crm.firebasestorage.app",
  messagingSenderId: "670810468772",
  appId: "1:670810468772:web:52c871f3ef8770eb0a5131"
};

let app;

if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

export const auth = getAuth(app);
export const db = getFirestore(app);

export const isFirebaseConfigured = () => true;

export default app;